import { render, staticRenderFns } from "./MapeoColumna.vue?vue&type=template&id=abcea20c&"
import script from "./MapeoColumna.vue?vue&type=script&lang=ts&"
export * from "./MapeoColumna.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports